import { id } from "date-fns/locale";

export const Roles = [
  {
    id: 1,
    name: "Adquisición de Material",
    key: "purchase",
  },
  {
    id: 2,
    name: "Corte",
    key: "cut",
  },
  {
    id: 3,
    name: "Decoración",
    key: "decoration",
  },
  {
    id: 4,
    name: "Confección",
    key: "sewing",
  },
  {
    id: 5,
    name: "Empaque",
    key: "packing",
  },
  {
    id: 6,
    name: "Entrega",
    key: "delivery",
  },
  {
    id: 7,
    name: "Tercerización",
    key: "outsourcing",
  },
  {
    id: 7,
    name: "Administrador",
    key: "admin",
  },
  {
    id: 8,
    name: "Super Administrador",
    key: "superAdmin",
  },
  {
    id: 9,
    name: "Almacén",
    key: "warehouse",
  },
  {
    id: 10,
    name: "Salida de Almacén",
    key: "leave_warehouse",
  },
  {
    id: 11,
    name: "Admin de Odt",
    key: "admin_odt",
  },
  {
    id: 12,
    name: "Admin de Logística",
    key: "admin_logistics",
  },
  {
    id: 13,
    name: "Admin de contabilidad",
    key: "accounting_admin",
  },
  {
    id: 14,
    name: "Visualización ODT",
    key: "odt_viewer",
  }
];
